import { useContext } from "react";
import { Box, alpha, Stack, lighten, Divider, IconButton, Tooltip, styled, useTheme, CssBaseline, useMediaQuery } from "@mui/material";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import HeaderUserBox from "@layouts/Userbox";
import { SidebarContext } from "@utilities/contexts/SideBarContext";
import BreadcrumbsComponent from "@components/Breadcrumbs";

const HeaderWrapper = styled(Box)(
    ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background ?? "", 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
    const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
    const theme = useTheme();
    const isSmallerScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <HeaderWrapper
            display="flex"
            alignItems="center"
            sx={{
                boxShadow:
                    theme.palette.mode === "dark"
                        ? `0 1px 0 ${alpha(
                            lighten(theme.colors.primary.main, 0.7),
                            0.15
                        )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
                        : `0px 2px 8px -3px ${alpha(theme.colors.alpha.black[100], 0.2)}, 0px 5px 22px -4px ${alpha(
                            theme.colors.alpha.black[100],
                            0.1
                        )}`,
            }}
        >
            <CssBaseline />
            <Box display={"flex"}>
                <Box
                    component="span"
                    sx={{
                        marginRight: 1,
                        display: { xs: "inline-block", lg: "none" },
                    }}
                >
                    <Tooltip arrow title="Toggle Menu">
                        <IconButton color="primary" onClick={toggleSidebar}>
                            {!sidebarToggle ? <MenuTwoToneIcon fontSize="small" /> : <CloseTwoToneIcon fontSize="small" />}
                        </IconButton>
                    </Tooltip>
                </Box>
                {!isSmallerScreen && (<Stack direction="row" divider={<Divider orientation="vertical" flexItem />} alignItems="center" spacing={2}>
                    <BreadcrumbsComponent />
                </Stack>)}
            </Box>
            <Box display="flex" alignItems="center" sx={{ wordBreak: "break-word" }}>
                <HeaderUserBox />
            </Box>
        </HeaderWrapper>
    );
}

export default Header;
